// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowSmallDownIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowSmallDownIcon" ref={forwardedRef} {...props}>
      <path d="M13.993 10.007 9.75 14.25l-4.243-4.243 1.061-1.06 3.182 3.182 3.182-3.182z" />
      <path d="M9 12.746v-6h1.5v6z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowSmallDownIcon = /* @__PURE__ */ Object.assign(
  ArrowSmallDownIconComponent,
  { displayName: 'ArrowSmallDownIcon' },
);
